import React from 'react'
import { css } from '@emotion/css'
import { PureQueryOptions } from 'apollo-client'
import { GridType, Library } from '../../helpers/ui-interfaces'
import { LibraryGridPanelID } from '../../helpers/drilldown-ui-interfaces'
import { Organization, Role } from '@contrast-security-inc/base-types'
import { Drawer } from '@contrast-security-inc/design-system-popovers'
import { LibraryUsageGridProvider } from '../library-usage-grid/library-usage-context'
import { useLibrariesPageContext } from '../../pages'
import { buildRepoLink } from '../cell-content/build-repo-link'
import { DrilldownContentViewTabs } from './drilldown-content-view/drilldown-content-view-tabs'
import { DrilldownActions } from './drilldown-actions'
import { DrilldownHeader } from './drilldown-header'

interface Props {
  onClose: () => void
  organizationID: string
  applicationID?: string
  selectedPanelTabId: LibraryGridPanelID
  refresh?: () => Promise<any>
  refetchQueries?: PureQueryOptions[]
  ossEnabled: boolean | undefined
  gridType: GridType
  organization: Organization
  library: Library
  organizationRole?: Role
}

export const LibraryDrillDownPanel = ({
  onClose,
  ossEnabled,
  selectedPanelTabId,
  refresh,
  refetchQueries,
  organizationID,
  applicationID,
  gridType,
  organization,
  library,
  organizationRole
}: Props) => {
  const { language, group, versions, name } = library
  const { isStaticGrid } = useLibrariesPageContext()

  const sourceLink = buildRepoLink({
    language,
    group,
    version: versions.current.version,
    name
  })

  return (
    <LibraryUsageGridProvider>
      <Drawer
        className={css`
          top: 50px !important;
          z-index: 1001;
        `}
        isOpen={!!library}
        onClose={onClose}
        placement="right"
        size="lg"
        testId={`grid-drilldown-panel-${library ? 'open' : 'closed'}`}
        title={
          <DrilldownHeader
            showWhiteBackgroundColor
            organizationID={organizationID}
            applicationID={applicationID}
            library={{ ...library, language: library.language.toString() }}
            renderActions={
              refresh &&
              !isStaticGrid &&
              organizationRole && (
                <DrilldownActions
                  organizationID={organizationID}
                  applicationID={applicationID}
                  libraryHash={library.hash}
                  sourceLink={sourceLink}
                  refresh={refresh}
                  library={library}
                  refetchQueries={refetchQueries}
                  organizationRole={organizationRole}
                  onClose={onClose}
                />
              )
            }
          />
        }
        body={
          <DrilldownContentViewTabs
            library={library}
            defaultTabID={selectedPanelTabId}
            ossEnabled={ossEnabled}
            gridType={gridType}
            applicationID={applicationID}
            organizationID={organizationID}
            organization={organization}
          />
        }
      />
    </LibraryUsageGridProvider>
  )
}
